module.exports = __webpack_public_path__ + "static/social_networking-561e8c1d345be71011b460f0580fe30c.svg";